import { render, staticRenderFns } from "./PhoneInfo.vue?vue&type=template&id=77e50a1e&"
import script from "./PhoneInfo.vue?vue&type=script&lang=js&"
export * from "./PhoneInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports